module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/spectralcount/spectralcount.component.css
// module id = ./src/app/spectralcount/spectralcount.component.css
// module chunks = main